import { gql, useQuery } from '@apollo/client'

import {
  ConsoleOrderDetailQuery,
  ConsoleOrderDetailQueryVariables,
  UserCartStoreItemPurchaseProceedFragment,
  UserCartTransactionOrderDetailFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'
import {
  addCollectionToCollectionFee,
  groupItemsByCollection,
} from '@/core/cart'
import { convertUserCartItemsToSku } from '@/core/sku'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { router } = useRouter<{ orderId: string; userId: string }>()

  const { data, loading } = useQuery<
    ConsoleOrderDetailQuery,
    ConsoleOrderDetailQueryVariables
  >(QUERY, {
    variables: {
      id: router.query.orderId,
      userId: router.query.userId,
    },
  })

  const cartItems = convertUserCartItemsToSku(
    data?.artistUserCartTransactionOrder?.items ?? null
  ) as UserCartStoreItemPurchaseProceedFragment['items']

  return {
    state: {
      loading,
      userId: router.query.userId,
      transactionOrder: data?.artistUserCartTransactionOrder ?? null,
      cartItemsByCollection: groupItemsByCollection(cartItems),
      artistId: user?.uid ?? '',
      purchaseType: data?.artistUserCartTransactionOrder.isKonbini
        ? 'konbini'
        : data?.artistUserCartTransactionOrder.paymentType,
      systemFee: addCollectionToCollectionFee(
        data?.artistUserCartTransactionOrder?.checkoutFees?.collections,
        data?.artistUserCartTransactionOrder?.items.map(
          ({ item }) => item.collection
        )
      ),
      formattedPrepaidPointBalance:
        data?.prepaidPointBalance?.formattedPrepaidPointBarance ?? 0,
      shippingFee:
        data?.artistUserCartTransactionOrder?.checkoutFees?.shipping ?? null,
      konbiniFee:
        data?.artistUserCartTransactionOrder?.checkoutFees?.konbini ?? null,
    },
    actions: {},
  }
})

const QUERY = gql`
  query ConsoleOrderDetail($id: ID!, $userId: String!, $skuId: String) {
    artistUserCartTransactionOrder(id: $id, userId: $userId) {
      itemOrders {
        user {
          id
          fullName
          phoneNumber
          displayName
          formattedPhoneNumber @client
          isPhoneNumberVerified
          status
          credit {
            ...PaymentDetail
          }
          ...UserAddress
        }
      }
      ...UserCartTransactionOrderDetail
    }
    prepaidPointBalance {
      lastUpdatedAt
      prepaidPointId
      balance
      formattedPrepaidPointBarance @client
    }
  }
  ${UserCartTransactionOrderDetailFragmentDoc}
`
